import React from 'react';

function PhoneOutline(props) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.94718 10.7264C8.66032 12.1843 9.84213 13.3608 11.3033 14.0673C11.4102 14.1179 11.5285 14.1399 11.6465 14.1309C11.7644 14.122 11.878 14.0825 11.9761 14.0164L14.1276 12.5817C14.2228 12.5182 14.3322 12.4795 14.4461 12.4691C14.56 12.4586 14.6747 12.4767 14.7798 12.5218L18.8049 14.2468C18.9416 14.3049 19.0558 14.4058 19.1302 14.5344C19.2045 14.663 19.2351 14.8123 19.2173 14.9598C19.09 15.9553 18.6043 16.8703 17.851 17.5335C17.0978 18.1966 16.1286 18.5625 15.125 18.5626C12.0253 18.5626 9.05252 17.3312 6.86069 15.1394C4.66886 12.9475 3.4375 9.97477 3.4375 6.87505C3.43755 5.87145 3.80342 4.90228 4.46659 4.14901C5.12975 3.39574 6.04475 2.91002 7.04026 2.7828C7.18774 2.76495 7.33703 2.79551 7.46562 2.86989C7.59422 2.94426 7.69517 3.05841 7.75325 3.19514L9.47978 7.22371C9.52444 7.32791 9.54264 7.44154 9.53275 7.55448C9.52287 7.66742 9.4852 7.77616 9.42312 7.87101L7.99343 10.0555C7.92836 10.1538 7.88989 10.2673 7.88179 10.3848C7.87368 10.5024 7.89621 10.6201 7.94718 10.7264V10.7264Z"
        stroke="#616161"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PhoneOutline;
